module.exports = "/_next/static/images/16e39badd7f1359ef7d2c841512b3c15-card-background-left-xs.jpg.webp";